export type MissingDataItem = {
	name: string
};

export const findMissingNames = (dataArray: MissingDataItem[], nameList: string[]): string[] => {
	const dataNames = new Set(dataArray.map(item => item.name));
	return nameList.filter(name => !dataNames.has(name));
};
